/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    FLOATING_HELP_BUTTON
 * Date:         2026-07-13
 * Modified By:  Maya (UI/UX)
 *
 * Description:
 * Reusable floating "?" help button (FAB). Rendered on feature pages
 * (Inventory, Broadcasts) and deep-links to the matching Help Center
 * docs category in a new tab. One component, one `href` prop per page.
 *
 * File Size Check:
 * - Current: ~35 lines
 * - Decision: Proceed (well within component limit)
 *
 * Related Files:
 * - client/src/components/ui/FloatingHelpButton.module.scss
 * - client/src/features/inventory/InventoryPage.tsx
 * - client/src/features/broadcast/pages/broadcasts-list/BroadcastsListPage.tsx
 */
import React from "react";
import styles from "./FloatingHelpButton.module.scss";

interface FloatingHelpButtonProps {
  /** Docs URL the button opens (in a new tab) */
  href: string;
  /** Accessible label / tooltip text */
  label?: string;
}

const FloatingHelpButton: React.FC<FloatingHelpButtonProps> = ({
  href,
  label = "Help",
}) => {
  return (
    <a
      className={styles.helpFab}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      title={label}
    >
      <span className={styles.mark} aria-hidden="true">?</span>
    </a>
  );
};

export default FloatingHelpButton;
